/* eslint-disable no-nested-ternary */
import React from "react";
import { withRouter } from "react-router-dom";
import { Tooltip } from "antd";
import { Bell, Info, MapTrifold, SignOut, User } from "phosphor-react";
import DrawerToggleButton from "../SideDrawer/DrawerToggleButton";
import HeaderMenuItems from "../Header/HeaderMenuItems";
import NotifiationDropdown from "../MyNotifications/MyNotifiationDropdown";
import "./Toolbar.css";
import useNotificationDropdown from "../../hooks/modals/useNotificationDropdown";
import useNotificationStore from "../../stores/useNotificationStore";
import useNotificationsList from "../../hooks/notifications/useNotificationsList";
import useAdminStore from "../../stores/useAdminStore";

const Toolbar = (props) => {
  const { user, history, isDirtyForm, renderDirtyNavModal, openSitemapModal, openLogoutModal } =
    props;
  const { isDropdownOpen, toggleNotificationDropdown } = useNotificationDropdown();

  const isAdmin = useAdminStore((state) => state.isAdmin);
  const hasUnreadNotifications = useNotificationStore((state) => state.hasUnread);
  useNotificationsList();

  const isActiveNotificationRoute = () => {
    const currentPath = history.location.pathname;
    let style = "";
    if (currentPath === "/my-notifications") {
      style = "active";
    }
    if (hasUnreadNotifications) {
      style = `${style} with-notification`;
    }
    return style;
  };

  return (
    <header className="toolbar">
      <nav className="toolbar__navigation">
        <div className="toolbar__toggle-button">
          <DrawerToggleButton click={props.drawerToggleHandler} />
        </div>
        <div className="toolbar__logo">
          <span>iPerform</span>
        </div>
        <div className="toolbar__navigation-items">
          <HeaderMenuItems
            user={props.user}
            isLineManager={props.isLineManager}
            isUserProfileValid={props.isUserProfileValid}
            setObjectivesFilters={props.setObjectivesFilters}
            isDirtyForm={isDirtyForm}
            renderDirtyNavModal={renderDirtyNavModal}
          />
        </div>
        <div className="spacer" />
        <div className="toolbar__navigation-items">
          <ul>
            {user?.isValidProfile && !isAdmin && (
              <Tooltip title="notifications" placement="bottom" mouseEnterDelay={1.0}>
                <span className="hidden-menuitem-label">Notifications</span>
                <li
                  className={`toolbar__navigation-icon ${isActiveNotificationRoute()}`}
                  onClick={toggleNotificationDropdown}
                  onKeyDown={(e) => (e.key === "Enter" ? toggleNotificationDropdown() : undefined)}
                  tabIndex={0}
                  role="menuitem"
                  aria-label="Open notifications"
                  id="toolbarNotifications"
                >
                  <Bell
                    color="rgba(55,81,157, 1)"
                    size={32}
                    className="toolbar__navigation-items-icon with-border "
                  />
                </li>
              </Tooltip>
            )}
            {isDropdownOpen && (
              <div>
                <div className="backdrop" onClick={toggleNotificationDropdown} />
                <NotifiationDropdown />
              </div>
            )}
            {!isAdmin && (
              <Tooltip title="my profile" placement="bottom" mouseEnterDelay={1.0}>
                <span className="hidden-menuitem-label">My Profile</span>
                <li
                  className="toolbar__navigation-icon"
                  onClick={() => {
                    if (isDirtyForm) {
                      renderDirtyNavModal("/");
                    } else {
                      history.push("/");
                    }
                  }}
                  onKeyDown={(e) =>
                    e.key === "Enter"
                      ? isDirtyForm
                        ? renderDirtyNavModal("/")
                        : history.push("/")
                      : undefined
                  }
                  tabIndex={0}
                  role="menuitem"
                  aria-label="Go to profile"
                  id="toolbarProfile"
                >
                  <User color="rgba(55,81,157, 1)" size={32} />
                </li>
              </Tooltip>
            )}
            <Tooltip title="about" placement="bottom" mouseEnterDelay={1.0}>
              <span className="hidden-menuitem-label">About</span>
              <li
                className="toolbar__navigation-icon"
                onClick={() => {
                  if (isDirtyForm) {
                    renderDirtyNavModal("/about");
                  } else {
                    history.push("/about");
                  }
                }}
                onKeyDown={(e) =>
                  e.key === "Enter"
                    ? isDirtyForm
                      ? renderDirtyNavModal("/about")
                      : history.push("/about")
                    : undefined
                }
                tabIndex={0}
                role="menuitem"
                aria-label="Go to about"
                id="toolbarAbout"
              >
                <Info color="rgba(55,81,157, 1)" size={32} />
              </li>
            </Tooltip>
            <Tooltip title="sitemap" placement="bottom" mouseEnterDelay={1.0}>
              <span className="hidden-menuitem-label">Site map</span>
              <li
                className="toolbar__navigation-icon"
                onClick={props.openSitemapModal}
                onKeyDown={(e) => (e.key === "Enter" ? openSitemapModal() : undefined)}
                tabIndex={0}
                role="menuitem"
                aria-label="Go to sitemap"
                id="toolbarSitemap"
              >
                <MapTrifold color="rgba(55,81,157, 1)" size={32} />
              </li>
            </Tooltip>
            <Tooltip title="logout" placement="bottom" mouseEnterDelay={1.0}>
              <span className="hidden-menuitem-label">Logout</span>
              <li
                className="toolbar__navigation-icon"
                onClick={props.openLogoutModal}
                onKeyDown={(e) => (e.key === "Enter" ? openLogoutModal() : undefined)}
                tabIndex={0}
                role="menuitem"
                aria-label="Logout of iPerform"
                id="toolbarLogout"
              >
                <SignOut color="rgba(55,81,157, 1)" size={32} />
              </li>
            </Tooltip>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default withRouter(Toolbar);
